import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TCreateProjectDto, useAvApi } from '@app-velocity/av-api-v2';
import { useUserData } from '@app-velocity/libs/auth';

export const CREATE_PROJECT_MUTATION_KEY = 'create-project-mutate';

export const useCreateProjectMutation = () => {
  const { projects } = useAvApi();
  const queryClient = useQueryClient();
  const user = useUserData();

  return useMutation({
    mutationKey: [CREATE_PROJECT_MUTATION_KEY],
    mutationFn: async (body: TCreateProjectDto) => {
      const response = await projects.postV2Projects(body);

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['projects', user.userId],
      });
    },
  });
};
